(ns trellis.button
  (:require
    [dnd.util :refer [cls non-empty-string?]]
    [trellis.tooltip]))

(defn delete-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "Delete"}
   [:path {:d "M25 8H7c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1M13 24c-.55 0-1-.45-1-1V13c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1M19 24c-.55 0-1-.45-1-1V13c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1"}]
   [:path {:d "M20 8h-8c-.55 0-1-.45-1-1V5c0-1.65 1.35-3 3-3h4c1.65 0 3 1.35 3 3v2c0 .55-.45 1-1 1m-7-2h6V5c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1zM21 30H11c-2.76 0-5-2.24-5-5V11c0-.55.45-1 1-1s1 .45 1 1v14c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V11c0-.55.45-1 1-1s1 .45 1 1v14c0 2.76-2.24 5-5 5"}]])

(defn add-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "Add"}
   [:path {:d "M15.57 29.29c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v25.14c0 .63-.51 1.14-1.14 1.14Z"}]
   [:path {:d "M28.14 16.71H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28"}]])

(defn edit-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "Edit"}
   [:path {:d "M10.46 29.32H3c-.63 0-1.14-.51-1.14-1.14v-7.46c0-.3.12-.59.33-.81L19.24 2.86c.65-.65 1.51-1 2.42-1 .92 0 1.78.36 2.43 1.01l4.21 4.24a3.443 3.443 0 0 1 0 4.84L11.27 28.98c-.21.21-.5.33-.81.33Zm-6.32-2.29h5.84l16.7-16.7c.44-.44.45-1.17 0-1.61l-4.21-4.24c-.22-.22-.5-.34-.81-.34s-.59.12-.81.33L4.14 21.19zm23.35-15.89"}]
   [:path {:d "M25.01 14.76c-.29 0-.58-.11-.81-.33l-7.46-7.46c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l7.46 7.46a1.14 1.14 0 0 1-.81 1.95"}]])

(defn success-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "Success"}
   [:path {:d "M11 26.43c-.3 0-.59-.12-.81-.33l-8-8.01a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l7.17 7.17L27.31 6.22c.43-.46 1.16-.49 1.62-.05.46.43.48 1.16.05 1.62L11.83 26.07c-.21.23-.51.36-.82.36h-.02Z"}]])

(defn remove-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "Remove"}
   [:path {:d "M27.86 29c-.29 0-.58-.11-.81-.33L4.19 5.81a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l22.86 22.86a1.14 1.14 0 0 1-.81 1.95"}]
   [:path {:d "M5 29c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62L27.05 4.19a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L5.81 28.67c-.22.22-.52.33-.81.33"}]])

(defn breeze-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :focusable "false"
         :data-icon-name "BreezeSingleStar"}
   [:path {:d "M29.62 15.12c-6.94 0-12.74-5.79-12.74-12.73 0-.48-.4-.88-.88-.88s-.88.4-.88.88c0 6.94-5.8 12.73-12.74 12.73-.49 0-.88.4-.88.88 0 .49.39.88.88.88 6.94 0 12.74 5.79 12.74 12.73 0 .48.4.88.88.88s.88-.4.88-.88c0-6.94 5.8-12.73 12.74-12.73.49 0 .88-.4.88-.88 0-.49-.39-.88-.88-.88"}]])

(defn link
  [{:keys [size
           href
           class]
    :or {size "sm"
         href "#"
         class ""}
    :as props}
   & children]
  (let [size-style {"sm" (cls
                          "text-trellis-typography-link-25-font-family"
                          "text-trellis-typography-link-25-font-size"
                          "font-trellis-typography-link-25-font-weight"
                          "tracking-trellis-typography-link-25-letter-spacing"
                          "leading-trellis-typography-link-25-line-height")
                    "md" (cls
                          "text-trellis-typography-link-100-font-family"
                          "text-trellis-typography-link-100-font-size"
                          "font-trellis-typography-link-100-font-weight"
                          "tracking-trellis-typography-link-100-letter-spacing"
                          "leading-trellis-typography-link-100-line-height")
                    "lg" (cls
                          "text-trellis-typography-link-200-font-family"
                          "text-trellis-typography-link-200-font-size"
                          "font-trellis-typography-link-200-font-weight"
                          "tracking-trellis-typography-link-200-letter-spacing"
                          "leading-trellis-typography-link-200-line-height")}
        ;; Remove keys we've explicitly handled and pass through the rest
        extra-props (dissoc props :size :href :class)]
    (into [:a (merge {:class (cls "underline"
                                  "trellis-color-specialty-link-on-fill-default"
                                  "hover:trellis-color-specialty-link-on-fill-hover"
                                  "active:trellis-color-specialty-link-on-fill-pressed"
                                  "disabled:trellis-color-specialty-link-on-fill-disabled"
                                  ;; font sizes, spacing etc
                                  (get size-style size)
                                  class)
                      :href href}
                     extra-props)]
          children)))

(defn button
  [{:keys [tooltip
           variant
           active
           size
           full-width
           disabled
           onClick
           onMouseEnter
           onMouseLeave
           type]
    :or {variant "primary"
         size "md"
         disabled false
         active false
         full-width false
         type "button"}}
   & children]
  {:pre [(contains? #{"primary"
                      "secondary"
                      "tertiary"
                      "destructive"
                      "transparent"}
                    variant)
         (contains? #{"xs" "sm" "md"} size)
         (or (nil? tooltip)
             (non-empty-string? tooltip))]}
  (let [variant-style {"primary" (if disabled
                                   (cls
                                     ; colors
                                    "bg-trellis-color-fill-primary-disabled"
                                    "border-trellis-color-border-primary-disabled"
                                    "text-trellis-color-text-primary-disabled")
                                   (cls
                                    (if active
                                      [; colors
                                       "bg-trellis-color-fill-primary-pressed"
                                       "border-trellis-color-fill-primary-pressed"
                                       "text-trellis-color-text-core-on-fill-default"]
                                      [; colors
                                       "bg-trellis-color-fill-primary-default"
                                       "border-trellis-color-fill-primary-default"
                                       "text-trellis-color-text-core-on-fill-default"])

                                     ; colors - hover
                                    "hover:bg-trellis-color-fill-primary-hover"
                                    "hover:border-trellis-color-fill-primary-hover"
                                    "hover:text-trellis-color-text-core-on-fill-default"

                                     ; colors - active
                                    "active:bg-trellis-color-fill-primary-pressed"
                                    "active:border-trellis-color-fill-primary-pressed"
                                    "active:text-trellis-color-text-core-on-fill-default"))
                       "secondary" (if disabled
                                     (cls
                                       ; colors
                                      "bg-trellis-color-fill-secondary-disabled"
                                      "border-trellis-color-border-secondary-disabled"
                                      "text-trellis-color-text-secondary-disabled")
                                     (cls
                                      (if active
                                        [; colors
                                         "bg-trellis-color-fill-secondary-pressed"
                                         "border-trellis-color-border-secondary-default"
                                         "text-trellis-color-text-secondary-default"]
                                        [; colors
                                         "bg-trellis-color-fill-secondary-default"
                                         "border-trellis-color-border-secondary-default"
                                         "text-trellis-color-text-secondary-default"])

                                       ; colors - hover
                                      "hover:bg-trellis-color-fill-secondary-hover"
                                      "hover:border-trellis-color-border-secondary-default"
                                      "hover:text-trellis-color-text-secondary-default"

                                       ; colors - active
                                      "active:bg-trellis-color-fill-secondary-pressed"
                                      "active:border-trellis-color-border-secondary-default"
                                      "active:text-trellis-color-text-secondary-default"))
                       "tertiary" (if disabled
                                    (cls
                                      ; colors
                                     "bg-trellis-color-fill-tertiary-disabled"
                                     "border-trellis-color-border-tertiary-disabled"
                                     "text-trellis-color-text-primary-disabled")
                                    (cls
                                     (if active
                                       [; colors
                                        "active:bg-trellis-color-fill-transitional-tertiary-pressed"
                                        "active:border-trellis-color-border-transitional-tertiary-default"
                                        "active:text-trellis-color-text-inverse-default"]
                                       [; colors
                                        "bg-trellis-color-fill-transitional-tertiary-default"
                                        "border-trellis-color-border-transitional-tertiary-default"
                                        "text-trellis-color-text-inverse-default"])

                                      ; colors - hover
                                     "hover:bg-trellis-color-fill-transitional-tertiary-hover"
                                     "hover:border-trellis-color-border-transitional-tertiary-default"
                                     "hover:text-trellis-color-text-inverse-default"

                                      ; colors - active
                                     "active:bg-trellis-color-fill-transitional-tertiary-pressed"
                                     "active:border-trellis-color-border-transitional-tertiary-default"
                                     "active:text-trellis-color-text-inverse-default"))
                       "transparent" (if disabled
                                       (cls
                                         ; colors
                                        "bg-trellis-color-fill-transparent-default"
                                        "border-trellis-color-fill-transparent-default"
                                        "text-trellis-color-text-interactive-default-disabled")
                                       (cls
                                        (if active
                                          [; colors
                                           "active:bg-trellis-color-fill-transparent-default"
                                           "active:border-trellis-color-fill-transparent-default"
                                           "active:text-trellis-color-text-interactive-default-pressed"]
                                          [; colors
                                           "bg-trellis-color-fill-transparent-default"
                                           "border-trellis-color-fill-transparent-default"
                                           "text-trellis-color-text-interactive-default"])

                                         ; colors - hover
                                        "hover:bg-trellis-color-fill-transparent"
                                        "hover:border-trellis-color-fill-transparent"
                                        "hover:text-trellis-color-text-interactive-default-hover"

                                         ; colors - active
                                        "active:bg-trellis-color-fill-transparent-default"
                                        "active:border-trellis-color-fill-transparent-default"
                                        "active:text-trellis-color-text-interactive-default-pressed"))
                       "destructive" (if disabled
                                       (cls
                                         ; colors
                                        "bg-trellis-color-fill-primary-disabled"
                                        "border-trellis-color-border-primary-disabled"
                                        "text-trellis-color-text-primary-disabled")
                                       (cls
                                        (if active
                                          [; colors
                                           "active:bg-trellis-color-fill-alert-pressed"
                                           "active:border-trellis-color-fill-alert-pressed"
                                           "active:text-trellis-color-text-alert-on-fill-default"]
                                          [; colors
                                           "bg-trellis-color-fill-alert-default"
                                           "border-trellis-color-fill-alert-default"
                                           "text-trellis-color-text-alert-on-fill-default"])

                                         ; colors - hover
                                        "hover:bg-trellis-color-fill-alert-hover"
                                        "hover:border-trellis-color-fill-alert-hover"
                                        "hover:text-trellis-color-text-alert-on-fill-default"

                                         ; colors - active
                                        "active:bg-trellis-color-fill-alert-pressed"
                                        "active:border-trellis-color-fill-alert-pressed"
                                        "active:text-trellis-color-text-alert-on-fill-default"))}
        size-style {"xs" (cls
                           ; font
                          "text-trellis-typography-detail-100-font-family"
                          "text-trellis-typography-detail-100-font-size"
                          "font-trellis-typography-detail-100-font-weight"
                          "tracking-trellis-typography-detail-100-letter-spacing"
                          "leading-trellis-typography-detail-100-line-height"

                           ; spacing
                          "py-trellis-space-100"
                          "px-trellis-space-300")
                    "sm" (cls
                           ; font
                          "text-trellis-typography-detail-100-font-family"
                          "text-trellis-typography-detail-100-font-size"
                          "font-trellis-typography-detail-100-font-weight"
                          "tracking-trellis-typography-detail-100-letter-spacing"
                          "leading-trellis-typography-detail-100-line-height"

                           ; spacing
                          "py-trellis-space-200"
                          "px-trellis-space-400")
                    "md" (cls
                           ; font
                          "text-trellis-typography-heading-50-font-family"
                          "text-trellis-typography-heading-50-font-size"
                          "font-trellis-typography-heading-50-font-weight"
                          "tracking-trellis-typography-heading-50-letter-spacing"
                          "leading-trellis-typography-heading-50-line-height"

                           ; spacing
                          "py-trellis-space-250"
                          "px-trellis-space-600")}
        cursor-style (cls (if disabled
                            "cursor-not-allowed"
                            "cursor-pointer"))
        button [:button (cond-> {:tabIndex 0
                                 :type type
                                 :class (cls "antialiased"
                                             "transition-all"
                                             "inline-block"
                                             "overflow-hidden text-ellipsis"
                                             "whitespace-nowrap"
                                             "align-middle"
                                             "max-w-full"
                                             (when full-width
                                               "w-full")

                                             "[&_svg[data-icon-name]]:size-[14px]"
                                             "[&_svg[data-icon-name]]:leading-[14px]"
                                             "[&_svg[data-icon-name]]:text-current"

                                             ;; to handle embedding material icons for now
                                             "[&_svg.MuiSvgIcon-root]:size-[14px]"
                                             "[&_svg.MuiSvgIcon-root]:leading-[14px]"
                                             "[&_svg.MuiSvgIcon-root]:text-current"

                                             ;; adjust button group children by - rounded l & r for first/last, no rounding for anything else, shift every non-first child left 1px
                                             "[.trellis-button-group_&]:rounded-none [.trellis-button-group_&]:first:rounded-l [.trellis-button-group_&]:last:rounded-r"
                                             "[.trellis-button-group_&:not(:first-child)]:-ml-px"

                                             ;; colors
                                             (get variant-style variant)

                                             ;; font sizes, spacing etc
                                             (get size-style size)

                                             ;; pointer effect handling
                                             cursor-style

                                             ;; border styles
                                             "border-solid"
                                             "border-trellis-border-width-100"

                                             ;; radius
                                             "rounded-trellis-border-radius-100")

                                 ;; props we pass through to the underlying button
                                 :onClick onClick
                                 :onMouseEnter onMouseEnter
                                 :onMouseLeave onMouseLeave}
                          disabled
                          (assoc :disabled true))
                (into [:span {:class (cls "flex gap-trellis-space-200"
                                          "justify-center items-center"
                                          "text-center"
                                          "m-trellis-space-0 p-trellis-space-0"
                                          "w-full h-full")}]
                      children)]]
    (if tooltip
      [trellis.tooltip/tooltip {:title tooltip
                                :arrow true}
       button]
      button)))

(defn button-group
  [props & children]
  (into [:div {:class (cls "flex flex-row"
                           "trellis-button-group"
                           "whitespace-nowrap")}]
        children))
